scrollOpacity();
scrollIndication();

$(window).scroll(function () {
    var self = $(this),
        container = $('.condensed'),
        isNarrow = $('.hero.narrow').length,
        isHome = $('body.page-1').length,
        scrollMargin = (isNarrow ? 540 : (isHome ? 215 : 920)),
        scrollTop = self.scrollTop();

    scrollOpacity();
    scrollIndication();

    $('.mega').fadeOut(150).removeClass('showing');
    $('header .na li').removeClass('hovered');

    if (self.width() < 992) {
        return;
    }

    if (self.width() < 768) {
        scrollMargin = 740;
    }

    if (scrollTop > scrollMargin) {
        container.slideDown(100);
    } else {
        container.slideUp(100);
        container.removeClass('active');
    }
});

$(window).resize(function () {
    var self = $(this),
        container = $('.condensed'),
        isNarrow = $('.hero.narrow').length,
        scrollMargin = isNarrow ? 645 : 1025;

    scrollIndication();

    if (self.width() < 992) {
        $('.mega').removeClass('showing');
        $('header .na li').removeClass('hovered');
        container.show();
    } else if (self.scrollTop() < scrollMargin) {
        container.hide();
    }
});

$('.condensed-nav').on('click', function () {
    var self = $(this),
        container = $('.condensed');

    container.toggleClass('active');
});

$('header .na li').on('mouseover', function () {
    var self = $(this),
        drops = $('.mega'),
        dropsShowing = $('.mega.showing'),
        drop = $('#mega-' + self.data('id'));

    $('header .na li').removeClass('hovered');

    self.addClass('hovered');

    if (drop.hasClass('showing')) {
        return;
    }

    if (drop.length < 1) {
        drops.stop(true).fadeOut(150).removeClass('showing');
    }

    if (dropsShowing.length < 1) {
        drop.stop(true).fadeIn(150);
    } else {
        drops.hide();
        drop.show();
    }

    drops.removeClass('showing');
    drop.addClass('showing');
});

$('header .na li').on('mouseleave', function () {
    if (!$('.mega').is(':visible')) {
        $('header .na li').removeClass('hovered');
    }
});

$('.mega').on('mouseleave', function () {
    setTimeout(function () {
        if ($('header .na li:hover').length > 0 || $('.mega:hover').length > 0) {
            return;
        }

        $('.mega').stop(true).fadeOut(150).removeClass('showing');
        $('header .na li').removeClass('hovered');
    }, 150);
});

$('.scroll').on('click', function () {
    $.scrollTo('.scroll-to-position', 750, {
        offset: {
            top: -50
        }
    });

    $(this).fadeOut(150);
});

$('.copy-two-col .btn').on('click', function (e) {
    if($('#enquiry').length) {
        e.preventDefault();
        $.scrollTo('#enquiry', 750);
    }
})

function scrollIndication() {
    var height = $(window).height();
    var width = $(window).width();
    var isNarrow = (width < 769);
    var offset = isNarrow ? 760 : 1040;

    if (height > offset || $(window).scrollTop() > 0) {
        $('.scroll').fadeOut(150);
    } else if (height < 1000) {
        $('.scroll').fadeIn(150);
    }
}

function scrollOpacity() {
    const speed = 600;
    var opacity = 1 - ($(this).scrollTop() / speed);

    $('header').css('pointer-events', 'all');

    if (opacity <= 0) {
        $('header').css('pointer-events', 'none');

        opacity = 0;
    }

    $('header').css('opacity', opacity);
}

$(function($) {
    // lazy load images
    $('.lazy').lazy({
        threshold: 500,
    });

    // open floating popout menu
    $('#floating-more-button').on('click', function (e) {
        e.preventDefault();
        $('#floating-buttons-wrapper').toggleClass('opened');
        $('#floating-overlay').toggleClass('showing');
    })
});